import React, { useState, useEffect } from "react";
import ThankyouPage from "./ThankyouPage"; 

export default function LoginCaseStudy({  selectedCaseStudy, onClose, caseStudies }) {
  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    caseStudy:selectedCaseStudy || "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.fullname || !formData.email || !formData.caseStudy) {
      setError("Please fill all fields");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const payload = {
        fullName: formData.fullname,
        email: formData.email,
        project: `Case Study - ${formData.caseStudy}`,
      }

      const response = await fetch(`${process.env.REACT_APP_BASE_URL}get_login_info/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Failed to submit data");
      }

      setSubmitted(true); 
    } catch (err) {
      console.error("Error submitting form:", err);
      setError("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  
  useEffect(() => {
    if (submitted) {
      const timer = setTimeout(() => {
        setSubmitted(false);
        onClose(); 
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [submitted, onClose]);

  if (submitted) {
    return <ThankyouPage />;
  }

  return (
    <div className="login-overlay">
      <div className="login-popup">
        <button className="close-btn" onClick={onClose}>
          ×
        </button>
        <h2>Request Info</h2>

        <form onSubmit={handleSubmit}>
          <label>FullName</label>
          <input
            type="text"
            name="fullname"
            placeholder="Enter your name"
            value={formData.fullname}
            onChange={handleChange}
            required
          />

          <label>Email</label>
          <input
            type="email"
            name="email"
            placeholder="Enter your email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <label>Select Case Study</label>
          <select
            name="caseStudy"
            value={formData.caseStudy}
            onChange={handleChange}
            required
          >
            <option value="">Select a case study</option>
            {caseStudies && caseStudies.length > 0
              ? caseStudies.map((p, idx) => (
                  <option key={idx} value={p.title}>
                    {p.title}
                  </option>
                ))
              : <option disabled>Loading...</option>}
          </select>

          {error && <p className="error">{error}</p>}

          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? "Submitting..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
}
